import styled from 'styled-components'

import { EmptyMessage } from 'src/components'

export const Container = styled.div`
  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const SpinnerContainer = styled.div`
  margin: 0.8rem;
`

export const DashboardErrorMessage = styled(EmptyMessage)`
  padding: 0 0.8rem;
`
